import { HistogramGenericCanvasLayout } from './HistogramGenericCanvasLayout.js';
import { applyOpacityToCanvas } from '../../../core/utils/apply-opacity-to-canvas.js';
import { useHighlightedSeriesIdState } from '../../hooks/store/selectors.js';
import { useHistogramFilteredData } from '../../hooks/useHistogramFilteredData.js';
import { safeGet } from '../../providers/HistogramDataProvider.js';

interface HistogramHighlightedCanvasLayoutProps {
  handleOpacity: (val: string) => void;
}

export const HistogramHighlightedCanvasLayout = ({
  handleOpacity,
}: HistogramHighlightedCanvasLayoutProps) => {
  const highlightedSeriesId = useHighlightedSeriesIdState();
  const { series, seriesMap } = useHistogramFilteredData();
  handleOpacity(applyOpacityToCanvas(highlightedSeriesId));

  if (!highlightedSeriesId) {
    return null;
  }

  const filteredSeries = series.filter(
    (s) => safeGet(seriesMap, s).id === highlightedSeriesId,
  );

  return <HistogramGenericCanvasLayout series={filteredSeries} />;
};
